"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceById = void 0;
function replaceById(array, id, replacement) {
    return array.map((other) => {
        if (other.id === id) {
            return typeof replacement === "function"
                ? replacement(other)
                : replacement;
        }
        return other;
    });
}
exports.replaceById = replaceById;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVwbGFjZUJ5SWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvcmVwbGFjZUJ5SWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsU0FBZ0IsV0FBVyxDQUN6QixLQUFVLEVBQ1YsRUFBVyxFQUNYLFdBQXFDO0lBRXJDLE9BQU8sS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLEtBQUssRUFBRSxFQUFFO1FBQ3pCLElBQUksS0FBSyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUU7WUFDbkIsT0FBTyxPQUFPLFdBQVcsS0FBSyxVQUFVO2dCQUN0QyxDQUFDLENBQUMsV0FBVyxDQUFDLEtBQUssQ0FBQztnQkFDcEIsQ0FBQyxDQUFDLFdBQVcsQ0FBQztTQUNqQjtRQUNELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDO0FBYkQsa0NBYUMifQ==